export function getHideEmail(email?: string) {
  if (!email) return "";
  const reg = /(^[\w|.|_|-]+)(@.+)/;
  return email.replace(reg, ($1, $2, $3) => {
    let hideWord = `${$2.slice(
      0,
      $2.length > 7 ? 4 : Math.floor($2.length / 2)
    )}****`;
    return `${hideWord}${$3}`;
  });
}

export function getHidePhone(phone?: string) {
  if (!phone) return "";
  const reg = /(\d{4})(\d{4})(\d+)/;
  return phone.replace(reg, ($1, $2, $3, $4) => `${$2}****${$4}`);
}
